export const getCurrencySymbol = (currency = 'USD') => {
  return Number()
    .toLocaleString(undefined, { currency, style: 'currency' })
    .slice(0, 1);
};
